import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useSelectedOnBehalfOfUserId } from '../analyticsSettings/selectors';
import {
  useCanAccessCampaignsInsights,
  useCanCreateCampaigns,
  useIsCampaignAnalyticsForExecutiveSponsorsAndOrganizersEnabled,
} from '../campaignRights';
import { useExperimentTreatmentWithoutReporting } from '../experiments';

export const useIsCampaignsEntryPointVisible = (): boolean => {
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const canAccessCampaignInsights = useCanAccessCampaignsInsights();
  const canCreateCampaigns = useCanCreateCampaigns();
  const isExecutiveSponsorAndCoOrganizerAnalyticsEnabled =
    useIsCampaignAnalyticsForExecutiveSponsorsAndOrganizersEnabled();
  const hasCampaignAnalyticsAccess = isExecutiveSponsorAndCoOrganizerAnalyticsEnabled
    ? canAccessCampaignInsights
    : canCreateCampaigns;
  const selectedOnBehalfOfUserId = useSelectedOnBehalfOfUserId();
  const isLeaderSelectedOnBehalfOfViewer = !!selectedOnBehalfOfUserId;

  return isVivaEngagePremium && hasCampaignAnalyticsAccess && isLeaderSelectedOnBehalfOfViewer === false;
};
